module.exports = __webpack_public_path__ + "static/media/apple_pay.a86fd1bd.svg";